const ROOT_KEY = "saas_admin";

export const queryKeys = {
  features: (accountId: number, currentPage: number) => [ROOT_KEY, "features", { accountId, currentPage }],
  account: (accountId: number) => [ROOT_KEY, "account", { accountId }]
};
